import { Mail, Phone, MapPin, ArrowLeft, Users, Target, Shield, Zap } from 'lucide-react';
import { Logo } from '../Logo';
import { Footer } from '../Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0B] text-white">
      <nav className="sticky top-0 z-50 bg-[#0A0A0B]/80 backdrop-blur-xl border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2"><Logo /></a>
          <a href="/" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors"><ArrowLeft className="w-4 h-4" />Back to Home</a>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 md:px-8 py-20">
        <h1 className="text-4xl sm:text-5xl font-bold font-outfit mb-6">About D3 Command</h1>
        <p className="text-lg text-zinc-400 mb-16 max-w-2xl leading-relaxed">
          We build enterprise software that turns conversations into execution. D3 Command is an AI-powered operational governance platform trusted by teams who need accountability, speed, and compliance.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
          {[
            { icon: Target, title: 'Our Mission', text: 'Eliminate the gap between decisions and execution. Every meeting should produce trackable outcomes, every risk should be visible, and every team member should know exactly what to do next.' },
            { icon: Users, title: 'Who We Serve', text: 'Operations leaders, GRC teams, consultants, and enterprise organizations that need to turn conversations into measurable results without losing anything in translation.' },
            { icon: Shield, title: 'Enterprise-Grade', text: 'Built with multi-tenancy, role-based access control, audit trails, and compliance-ready workflows from day one. No add-ons required.' },
            { icon: Zap, title: 'AI-First Approach', text: 'Our AI pipeline extracts tasks, risks, and decisions from every meeting automatically. No manual note-taking, no missed action items, no excuses.' },
          ].map(({ icon: Icon, title, text }) => (
            <div key={title} className="p-6 rounded-2xl bg-white/[0.03] border border-white/5">
              <div className="w-10 h-10 rounded-xl bg-indigo-500/10 flex items-center justify-center mb-4"><Icon className="w-5 h-5 text-indigo-400" /></div>
              <h3 className="text-lg font-semibold text-white mb-2">{title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>

        <div className="p-8 rounded-2xl bg-gradient-to-br from-indigo-500/5 to-cyan-500/5 border border-indigo-500/10 mb-20">
          <h2 className="text-2xl font-bold mb-4">D3 Global Holdings LLC</h2>
          <p className="text-zinc-400 mb-6 leading-relaxed">
            D3 Command is a product of D3 Global Holdings LLC, headquartered in Dallas, Texas. We are focused on building intelligent enterprise tools that drive operational excellence.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
            <div className="flex items-center gap-3 text-zinc-400"><MapPin className="w-4 h-4 text-indigo-400 shrink-0" />2807 Allen St #2164, Dallas, TX 75204</div>
            <a href="mailto:support@d3command.com" className="flex items-center gap-3 text-zinc-400 hover:text-indigo-400 transition-colors"><Mail className="w-4 h-4 text-indigo-400 shrink-0" />support@d3command.com</a>
            <a href="tel:+18888696184" className="flex items-center gap-3 text-zinc-400 hover:text-indigo-400 transition-colors"><Phone className="w-4 h-4 text-indigo-400 shrink-0" />(888) 869-6184</a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
